import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface UrlService {
  buildServerApiUrl(...parts: string[]): string;
}

export interface Folder {
  FolderId: string;
  FolderName: string;
}

export interface UnitFolder extends Folder {
  ParentFolderId: string;
  IsArchived: boolean;
}

export const URL_SERVICE_TOKEN = new InjectionToken<UrlService>('UrlService');
export const FOLDER_SERVICE_TOKEN = new InjectionToken<FolderService>('FolderService');

@Injectable({
  providedIn: 'root'
})
export class FolderService {
  public constructor(
    public readonly httpClient: HttpClient,
    @Inject(URL_SERVICE_TOKEN) public readonly urlService: UrlService
  ) {}

  public createFolder(folderId: string, folderName: string): Observable<UnitFolder> {
    const url = this.urlService.buildServerApiUrl('Teacher/UnitFolder', folderId);

    return this.httpClient.post<UnitFolder>(url, { Value: folderName });
  }
}
